import type { PropsWithChildren } from "react";

import { X as CloseIcon, Menu02 } from "@untitledui/icons";
import {
	Button as AriaButton,
	Dialog as AriaDialog,
	DialogTrigger as AriaDialogTrigger,
	Modal as AriaModal,
	ModalOverlay as AriaModalOverlay,
} from "react-aria-components";
import { Link } from "react-router";

import { CompanyLogo } from "@/assets/logos/company-logo";
import { ROUTES } from "@/constants/routes";
import { cx } from "@/utils/cx";

export const MobileNavigationHeader = ({ children }: PropsWithChildren) => {
	return (
		<header
			className="flex h-16 items-center justify-between border-b border-secondary bg-primary py-3 pr-2 pl-4 lg:hidden"
			id="mobile-header"
		>
			<div className="flex w-full items-center justify-between gap-2">
				<Link to={ROUTES.DASHBOARD}>
					<CompanyLogo isMobile={true} />
				</Link>
			</div>
			<AriaDialogTrigger>
				<AriaButton
					aria-label="Expand navigation menu"
					className="group flex items-center justify-center rounded-lg bg-primary p-2 text-fg-secondary outline-focus-ring hover:bg-primary_hover hover:text-fg-secondary_hover focus-visible:outline-2 focus-visible:outline-offset-2"
				>
					<Menu02 className="size-6 transition duration-200 ease-in-out group-aria-expanded:opacity-0" />
					<CloseIcon className="absolute size-6 opacity-0 transition duration-200 ease-in-out group-aria-expanded:opacity-100" />
				</AriaButton>
				<AriaModalOverlay
					className={({ isEntering, isExiting }) =>
						cx(
							"fixed inset-0 z-50 cursor-pointer bg-neutral-900/70 pr-14 backdrop-blur-md lg:hidden",
							isEntering && "duration-300 ease-in-out animate-in fade-in",
							isExiting && "duration-200 ease-in-out animate-out fade-out",
						)
					}
					isDismissable
				>
					{({ state }) => (
						<>
							<AriaButton
								aria-label="Close navigation menu"
								className="fixed top-3 right-2 flex cursor-pointer items-center justify-center rounded-lg p-2 text-fg-white outline-focus-ring hover:bg-white/10 hover:text-fg-white focus-visible:outline-2 focus-visible:outline-offset-2"
								onPress={() => state.close()}
							>
								<CloseIcon className="size-6" />
							</AriaButton>

							<AriaModal className="relative h-dvh w-full max-w-[var(--width-main-sidebar)] min-w-65 cursor-auto overflow-hidden bg-linear-45 from-linear-secondary to-linear-primary will-change-transform">
								<AriaDialog className="relative h-full outline-hidden focus:outline-hidden">
									{children}
								</AriaDialog>
							</AriaModal>
						</>
					)}
				</AriaModalOverlay>
			</AriaDialogTrigger>
		</header>
	);
};
